<template>
  <v-app id="country">
    <v-content>
      <v-container class="fill-height">
        <v-row class="w-100" justify="center" align="center">
          <v-col :cols="12">
            <v-row justify="space-between">
              <h3
                class="text-center display-3 ma-3 w-100 groen text-uppercase"
                style="font-family: 'Nunito' !important;font-weight:900"
              >Kies je land</h3>
              <v-divider></v-divider>
              <v-col v-for="card in cards" :key="card.title" :cols="card.flex">
                <!--v-ripple="{ class: 'white' }"-->
                <v-card
                  class="py-5 mt-5 bg-transparent"
                  :to="card.title=='Nederland'?{path: '/pre-order'}:{path:`/enroll/${productId}`}"
                >
                  <v-img
                    :src="card.src"
                    class="white--text ma-3 mx-auto text-center"
                    cover
                    style="border-radius:50%;width:150px"
                  ></v-img>
                  <h2 class="text-center pt-4 groen" v-text="card.title"></h2>
                  <p class="my-2 text-center px-2" v-if="card.title == 'Nederland'">
                    <span class="text-uppercase danger--text">Let op: </span>Dit betreft een Pre-order. Op dit moment is er nog geen type goedkeuring voor de elektrische steps in Nederland. Om deze reden kunnen we alleen nog Pre-orders verzamelen. Wil jij als eerste een Steppi rijden in Nederland? Plaats dan nu je Pre-order!
                  </p>

                  <p
                    class="my-2 text-center px-2"
                    v-else
                  >In Vlaanderen zijn de elektrische steps wel toegestaan! Klik hierboven om nu een Steppi te bestellen! 🛴</p>
                </v-card>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-container>
    </v-content>
  </v-app>
</template>

<script>
export default {
  data: () => ({
    productId: null,
    cards: [
      {
        title: "Nederland",
        src: require("./images/netherlands.png"),
        flex: 6
      },
      {
        title: "Vlaanderen",
        src: require("./images/belgium.png"),
        flex: 6
      }
    ]
  }),
  mounted() {
    this.productId = this.$route.params.id;
  }
};
</script>

<style src="./Country.scss" scoped lang="scss"></style>
